import React, { useEffect, useState } from 'react';
import { Link } from 'gatsby';
import { globalHistory } from '@reach/router';
import { Arrow, BgImage, Loader, Neon } from '../../components';
import { Wrapper, Content } from './Home.styled';

export default function Home({ data }) {
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		// https://stackoverflow.com/questions/61274365/allow-component-to-detect-route-change-in-gatsby
		// https://stackoverflow.com/a/61664193
		return globalHistory.listen(({ action }) => {
			if (action === 'PUSH') {
				setLoading(false);
			}
		});
	}, [setLoading]);

	const handleSetLoading = () => {
		setTimeout(() => {
			setLoading(true);
		}, 100);
	};

	return (
		<Wrapper>
			{data?.bgImage?.childImageSharp?.gatsbyImageData && (
				<BgImage
					src={data.bgImage.childImageSharp.gatsbyImageData}
					alt="Background"
				/>
			)}
			<Content>
				{loading ? (
					<Loader size="large" />
				) : (
					<Link to="/about" onClick={handleSetLoading}>
						<Neon as="h1" color="flicker">
							Open
						</Neon>

						<Neon as="h2" color="green">
							Enter <Arrow />
						</Neon>
					</Link>
				)}
			</Content>
		</Wrapper>
	);
}
